<template>
  <v-card>
    <v-stepper v-model="e1" flat>
      <v-stepper-items>
        <v-stepper-content step="1" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4" flat>
            <v-card-title class="education_title">
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
              <v-divider vertical class="hidden-md-and-up ml-2 mr-2 mx-2"></v-divider>
              <v-divider vertical class="hidden-sm-and-down ml-5 mr-5"></v-divider>
              <div class="red--text text--darken-2 education_title_notitext">{{$store.state.CustomInfo.SiteNm}} 보안 교육 서약</div>
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2">
              본인은 정해진 기간 내에 귀사를 출입하는 데 사전에 <strong>허가된</strong> 업무만을 수행하고 귀사의 <strong>보안 규정을</strong> 준수하겠으며, 위 사항을 숙지하여 반드시 이행할 것을 <strong>서약</strong>합니다.<br>
            </v-card-text>
            <v-card-actions class="pb-0 pr-4 pl-4">
              <v-spacer></v-spacer>
              <v-checkbox v-model="checkbox1" color="black" class="text-caption mr-4">
                <template v-slot:label>
                  <div class="black--text">
                    서약합니다.
                  </div>
                </template>
              </v-checkbox>
              <v-btn width="100" @click="CheckPledge(1,checkbox1)" dark><v-icon>mdi-chevron-right</v-icon>다음</v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="2" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4" flat>
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">환경안전사고 예방 서약서</div>                
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text v-if="$store.state.CustomInfo.SiteId == 'SKMG14'" class="education_content text-center mt-5 mb-5" style="line-height: 1.5;">
              본인은 {{$store.state.CustomInfo.SiteNm}}의 <strong class="font-weight-black">S.G.R 10대 항목</strong>을 충분히 이해하고<br>{{$store.state.CustomInfo.SiteNm}}의 환경안전사고 예방에 적극 실천할 것을 서약합니다. <br>또한 위반 시 Penalty 사항에 대한 징계 의뢰에 동의합니다.
            </v-card-text>  
            <v-card-text v-else class="education_content text-center mt-5 mb-5" style="line-height: 1.5;">
              본인은 {{$store.state.CustomInfo.SiteNm}}의 <strong class="font-weight-black">S.G.R 8대 항목</strong>을 충분히 이해하고<br>{{$store.state.CustomInfo.SiteNm}}의 환경안전사고 예방에 적극 실천할 것을 서약합니다. <br>또한 위반 시 Penalty 사항에 대한 징계 의뢰에 동의합니다.
            </v-card-text>    
            <v-divider></v-divider>
            <div v-if="$store.state.CustomInfo.SiteId == 'SKMG14'" class="ma-10 hidden-xs-only">
              <v-card-text class="education_content" style="line-height: 1.5;">
                <div class="d-flex">1.&nbsp;<div>화학물질 취급/작업 時 지정된 보호구 착용</div></div>
                <div class="d-flex">2.&nbsp;<div>사고보고 기준 준수</div></div>
                <div class="d-flex">3.&nbsp;<div>작업 時 작업허가서 승인 후 작업</div></div>
                <div class="d-flex">4.&nbsp;<div>밀폐작업 時 산소농도/유해가스 측정</div></div>
                <div class="d-flex">5.&nbsp;<div>고소지역 작업 時 추락 예방 조치 후 작업</div></div>
                <div class="d-flex">6.&nbsp;<div>변경 관리 절차 준수</div></div>
                <div class="d-flex">7.&nbsp;<div>지정 된 장소 外 금연</div></div>
                <div class="d-flex">8.&nbsp;<div>사내 운송수단 안전수칙 준수</div></div>
                <div class="d-flex">9.&nbsp;<div>안전장치 임의 해제 금지</div></div>
                <div class="d-flex">10.&nbsp;<div>위험작업 時 2인 1조 작업</div></div>
              </v-card-text>       
            </div>
            <div v-else class="ma-10 hidden-xs-only">
              <v-card-text class="education_content" style="line-height: 1.5;">
                <div class="d-flex">1.&nbsp;<div>유해화학물질 취급/작업 時 지정된 보호구 착용</div></div>
                <div class="d-flex">2.&nbsp;<div>사고 보고 기준 준수 (즉시 보고/서면 보고</div>)</div>
                <div class="d-flex">3.&nbsp;<div>작업 時 작업허가서 승인 후 작업</div></div>
                <div class="d-flex">4.&nbsp;<div>밀폐작업 時 산소농도/유해가스 측정</div></div>
                <div class="d-flex">5.&nbsp;<div>고소지역 작업 時 추락 예방 조치 후 작업</div></div>
                <div class="d-flex">6.&nbsp;<div>변경 관리 절차 준수 (변경검토, 가동 전 점검</div>)</div>
                <div class="d-flex">7.&nbsp;<div>지정 된 장소 外 금역 (라이터 휴대 금지</div>)</div>
                <div class="d-flex">8.&nbsp;<div>사내 운송수단 안전수칙 준수</div></div>
              </v-card-text>       
            </div>
            <div v-if="$store.state.CustomInfo.SiteId == 'SKMG14'" class="ma-4 d-sm-none" >
              <v-card-text class="education_content" style="line-height: 1.5;">
                <div class="d-flex">1.&nbsp;<div>화학물질 취급/작업 時 지정된 보호구 착용</div></div>
                <div class="d-flex">2.&nbsp;<div>사고보고 기준 준수</div></div>
                <div class="d-flex">3.&nbsp;<div>작업 時 작업허가서 승인 후 작업</div></div>
                <div class="d-flex">4.&nbsp;<div>밀폐작업 時 산소농도/유해가스 측정</div></div>
                <div class="d-flex">5.&nbsp;<div>고소지역 작업 時 추락 예방 조치 후 작업</div></div>
                <div class="d-flex">6.&nbsp;<div>변경 관리 절차 준수</div></div>
                <div class="d-flex">7.&nbsp;<div>지정 된 장소 外 금연</div></div>
                <div class="d-flex">8.&nbsp;<div>사내 운송수단 안전수칙 준수</div></div>
                <div class="d-flex">9.&nbsp;<div>안전장치 임의 해제 금지</div></div>
                <div class="d-flex">10.&nbsp;<div>위험작업 時 2인 1조 작업</div></div>
              </v-card-text>       
            </div>
            <div v-else class="ma-4 d-sm-none">
              <v-card-text class="education_content" style="line-height: 1.5;">
                <div class="d-flex">1.&nbsp;<div>유해화학물질 취급/작업 時 지정된 보호구 착용</div></div>
                <div class="d-flex">2.&nbsp;<div>사고 보고 기준 준수 (즉시 보고/서면 보고</div>)</div>
                <div class="d-flex">3.&nbsp;<div>작업 時 작업허가서 승인 후 작업</div></div>
                <div class="d-flex">4.&nbsp;<div>밀폐작업 時 산소농도/유해가스 측정</div></div>
                <div class="d-flex">5.&nbsp;<div>고소지역 작업 時 추락 예방 조치 후 작업</div></div>
                <div class="d-flex">6.&nbsp;<div>변경 관리 절차 준수 (변경검토, 가동 전 점검</div>)</div>
                <div class="d-flex">7.&nbsp;<div>지정 된 장소 外 금역 (라이터 휴대 금지</div>)</div>
                <div class="d-flex">8.&nbsp;<div>사내 운송수단 안전수칙 준수</div></div>
              </v-card-text>       
            </div>
            <v-divider></v-divider>    
            <v-card-text class="education_content lineHeight2">                
              상기 각 항의 내용을 충분히 숙지하였으며, 성실히 준수할 것을 서약합니다.             
            </v-card-text>

            <v-card-text class="d-flex">
              <v-spacer></v-spacer>
              <v-text-field v-model="oCustomInfo.CustomNm" readonly label="성명" placeholder="성명을 입력하세요." style="max-width:200px"></v-text-field>
              <v-btn class="ml-4 mt-3" width="100" @click="CheckPledge(2,oCustomInfo.CustomNm)" dark><v-icon>mdi-chevron-right</v-icon>서약</v-btn>
            </v-card-text>
        

            <v-card-text class="greeting_title text-center mb-4">
              {{$store.state.CustomInfo.SiteNm}} 대표이사 귀하
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="3" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4" flat>
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">골든룰 패널티 서약서</div>                
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2">                
              작업자 위반사항 발생 시 <strong class="red--text">경고 없이 즉시 적용</strong><br>                                                
            </v-card-text>    

            
            <table class="type09 text-center ">
              <thead>
                <tr>
                  <th scope="cols">구 분</th>
                  <th scope="cols">1차 위반</th>
                  <th scope="cols">2차 위반</th>
                  <th scope="cols">3차 위반</th>
                </tr>
              </thead>
              <tbody class="text_first_font">
                <tr>
                  <td>임직원</td>
                  <td>위반자 경고<br>(경위서 제출)</td>
                  <td>팀장 경고<br>(해당 직원 조치사항 제출)</td>
                  <td>인사(소)위원회 회부</td>
                </tr>
                <tr>
                  <td >협력업체<br>직원</td>
                  <td>협력업체 안전관리자가 위반자 구두 경고</td>
                  <td>[직원] 1개월 공장 출입 금지<br>[회사] 업체 안전관리자 면담</td>
                  <td>[직원] 6개월 공장 출입 금지<br>[회사] 업체 대표 면담. SHE 평가 반영</td>
                </tr>
                <tr>
                  <td colspan='4' class="text-left">
                    <div class="d-flex">※&nbsp;<div>위반 누적 기한 : 발생 시점으로부터 2년</div></div>
                    <div class="d-flex">※&nbsp;<div>1항 위반(사내 금연 및 사고 발생 시 S.G.R 위반자는 3차 위반과 동일하게 적용하여 처리</div></div>
                    <div class="d-flex">※&nbsp;<div>협력업체 정직원인 경우 협력업체 인사위원회 결정에 따라 출입 금지 해제 검토</div></div>
                  </td>
                </tr>
              </tbody>
            </table>
            
            <v-card-text class="education_content lineHeight2 text-center">                
              Golden Rule 위반 시, 적용되는 Penalty에 대해 <strong class="red--text">동의합니다.</strong>
            </v-card-text>
            <v-card-actions class="pb-0 pr-0">
              <v-spacer></v-spacer>
              <v-checkbox v-model="checkbox2" color="black" class="text-caption mr-4">
                <template v-slot:label>
                  <div class="black--text">
                    동의합니다.
                  </div>
                </template>
              </v-checkbox>    
              <v-btn width="100" @click="CheckPledge(3,checkbox2)" dark><v-icon>mdi-chevron-right</v-icon>동의하기</v-btn>
            </v-card-actions>
          </v-card>
          <!-- <v-card-actions>       
            <v-card-text class="text-caption">
              <v-checkbox v-model="checkbox2" color="black">
                <template v-slot:label>
                  <div class="black--text">
                    동의합니다.
                  </div>
                </template>
              </v-checkbox>    
            </v-card-text>       
            <v-spacer></v-spacer>
            <v-btn width="100" @click="CheckPledge(3,checkbox2)" dark><v-icon>mdi-chevron-right</v-icon>동의하기</v-btn>
          </v-card-actions> -->
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-card>    
</template>
<script>
import EventBus from '@/eventBus.js';

export default {
  components: {
  },
  data: () => ({  
    e1: 1,
    checkbox1: false,
    checkbox2: false,
    // cPledgeNm: "",
  }),
  props: {
    oCustomInfo: {
      type: Object,
      default () {
        return {}
      },
    },
  },
  
  mounted () {
    this.checkbox1 = false;
    this.checkbox2 = false;
  },

  methods: {
    CheckPledge(e1,checkboxvalue){
      if (e1 == 1 && checkboxvalue == false) {
        EventBus.$emit("onShowMsgBox", "서약에 대한 동의가 필요합니다.", "우우측 하단의 체크박스를 클릭하여 서약을 진행하여 주세요.");
        return
      } else if (e1 == 1 && checkboxvalue == true) {
        this.e1 = 2
      } else if (e1 == 2 && checkboxvalue != this.oCustomInfo.CustomNm) {
        EventBus.$emit("onShowMsgBox", "입력하신 이름과 일치하지 않습니다.", "회원가입시 입력하신 성함이 맞는지 확인하여 주세요.");
        return
      } else if (e1 == 2 && checkboxvalue == this.oCustomInfo.CustomNm) {
        this.e1 = 3
      } else if (e1 == 3 && checkboxvalue == false) {
        EventBus.$emit("onShowMsgBox", "서약에 대한 동의가 필요합니다.", "우우측 하단의 체크박스를 클릭하여 서약을 진행하여 주세요.");
        return
      } else if (e1 == 3 && checkboxvalue == true) {
        this.$emit('ClosePledge')
      } 
    },
  }
};
</script>

<style scoped lang="scss">
  @import "../publishing/visit.scss";

  .lineHeight2{
    line-height: 180%
  }
  .sec_box{
    margin: auto;        
    text-align: center;
    box-shadow: 0px 0px 1px 1px #f3f3f3; 
  }

  table.type09 {
    border-collapse: collapse;
    text-align: left;
    line-height: 1.5;
    width : 100%;
  }
  table.type09 thead th {
    padding-top: 10px;
    padding-bottom: 10px;
    font-weight: bold;
    vertical-align: top;
    border-bottom: 2px solid rgb(141, 141, 141);
    width: 25%;
  }
  table.type09 tbody th {
    width: 150px;
    padding: 10px;
    font-weight: bold;
    vertical-align: top;
    border-bottom: 1px solid #ccc;
    background: #f3f6f7;
  }
  table.type09 td {
    width: 350px;
    padding-top: 10px;
    padding-bottom: 10px;
    vertical-align:center;
    border-bottom: 1px solid #ccc;
  }

  // .secPledge_title {
  //   word-break: keep-all;

  //   @media screen and (min-width: 1065px) {
  //     font-size : 2.125rem;
  //     font-weight : 400;
  //     height : 80px;

  //     :deep(img) {
  //       height : 45px;
  //     }
  //   }

  //   @media screen and (min-width: 601px) and (max-width: 1064px){
  //     font-size: 1.5rem;
  //     font-weight: 500;

  //     :deep(.safe_title_text) {
  //       width : calc(90vw - 160px);
  //     }
      
  //     :deep(img) {
  //       width : 88px;
  //       align-self: start;
  //     }      
  //   }

  //   @media screen and (max-width: 600px) {
  //     padding : 0px;
  //     padding-top: 10px;
  //     padding-bottom: 10px;
  //     font-size: 1.3rem;
  //     font-weight: 500;

  //     :deep(.safe_title_text) {
  //       width : calc(90vw - 150px);
  //     }

  //     :deep(.safe_title_notitext) {
  //       width : calc(90vw - 170px);
  //     }

  //     :deep(img) {
  //       width : 82px;
  //       align-self: start;
  //     }
  //   }
  // }
</style>
